<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <el-form v-loading="versionLoading" ref="versionform" :rules="rules" :model="template" label-position="top">
      <el-form-item prop="template" label="模版" :label-width="formLabelWidth">
        <codemirror v-model="template.template" :options="cmOptions" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { updateAppVersionTemplate, getVersionDetail } from '@/api/app';
import { errorHandle } from '@/utils/error';
// import language js
import 'codemirror/mode/javascript/javascript.js'
// import theme style
import 'codemirror/theme/base16-dark.css'
const yaml = require('js-yaml');
export default {
  name: 'EditAppVersion',
  props: {
    appID: String,
    marketID: String,
    version: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    const checkTemplate = (rule, value, callback) => {
      const template = yaml.load(value)
      if (!template.spec.url) {
        callback('spec.url 是必填项')
      }
      if (!template.spec.createUser.path) {
        callback('spec.createUser.path 是必填项')
      }
      if (template.spec.lockUser && !template.spec.lockUser.path) {
        callback('spec.lockUser.path 是必填项')
      }
      if (template.spec.deleteUser && !template.spec.deleteUser.path) {
        callback('spec.deleteUser.path 是必填项')
      }
      callback()
    }
    return {
      cmOptions: {
        tabSize: 4,
        mode: 'text/javascript',
        theme: 'base16-dark',
        lineNumbers: true,
        cursorHeight: '20px',
        line: true
      },
      rules: {
        template: [
          { required: true, message: '版本模版是必须的', trigger: 'blur' },
          { validator: checkTemplate, trigger: 'blur' }
        ]
      },
      template: {
        template: ''
      },
      title: '更新SaaS版本模版',
      formLabelWidth: '100%',
      Loading: false,
      versionLoading: true
    };
  },
  created() {
    this.getVersionDetail()
  },
  methods: {
    getVersionDetail() {
      this.versionLoading = true
      getVersionDetail({ marketID: this.marketID, appID: this.appID, version: this.version })
        .then(res => {
          const yamlBody = yaml.dump(JSON.parse(res.template))
          this.template.template = yamlBody
          this.template.templateType = res.templateType
          this.versionLoading = false
        })
        .catch(err => {
          errorHandle(err)
          this.versionLoading = false
        });
    },
    submit() {
      this.Loading = true;
      this.$refs.versionform.validate(valid => {
        if (valid) {
          const data = {
            templateType: this.template.templateType,
            marketID: this.marketID,
            appID: this.appID,
            version: this.version,
            template: yaml.load(this.template.template)
          }
          updateAppVersionTemplate(data)
            .then(res => {
              this.Loading = false;
              this.onSuccess && this.onSuccess()
            })
            .catch(err => {
              this.Loading = false;
              errorHandle(err)
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.versionform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
 .CodeMirror-line {
   line-height: 20px!important;
 }
  ::v-deep .el-form-item__content {
   line-height: 20px!important;
 }
</style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/editAppSaaSVersionTemplate.vue